import { render, staticRenderFns } from "./ProductNewCompensationPage.vue?vue&type=template&id=1dd1f3c2&"
import script from "./ProductNewCompensationPage.vue?vue&type=script&lang=js&"
export * from "./ProductNewCompensationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports